import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../resources/requestInfo";

import { IProfile } from "./types";
import { getProfileInfoRoutes } from "./routes";

export const fetchProfileInfo = createAsyncThunk<IProfile>(
  "getProfile/fetchGetProfileInfo",
  async (_, { rejectWithValue }) => {
    try {
      // Новый API: GET /user
      const response = await axiosInstance.get(getProfileInfoRoutes.GET_PROFILE);
      return response.data;
    } catch (error: any) {
      console.log("error fetchProfileInfo >>>", error);
      return rejectWithValue(error.response?.data?.message || "Ошибка получения информации о пользователе");
    }
  }
);
